<template>
  <v-select
    v-model="value.value"
    :label="value == null ? '' : value.caption"
    :name="value == null ? '' : value.name"
    :readonly="value == null ? false : value.readonly"
    :required="value == null ? false : value.required"
    multiple
    :items="value.options"
    item-text="text"
    item-value="value"
    persistent-hint
    return-object
  >
    <template #label>
      <span v-if="value.required" class="red--text"><strong>* </strong></span
      >{{ value.caption }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: "MyFormSelectMultiple",
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          name: "MyFormSelectMultipleNotSet",
          value: [],
          caption: "not set",
          options: [],
        };
      },
    },
  },
  computed: {
    rules() {
      const rules = [];

      if (this.value.required) {
        const rule = (v) => !!v || "Required";

        rules.push(rule);
      }
      return rules;
    },
  },
};
</script>

<style scoped></style>
